import * as React from "react";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import * as redux from "redux";
import { TreeBranch } from "../../models/navigation";
import { AppState } from "../../store";
import { List } from "immutable";
import Settings from "../../settings";
import { Paths } from "../../constants";
import { Icon } from "../generic";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    navItems: state.nav.branches,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({

});

interface OwnProps {

}

interface ConnectedState {
    navItems: List<TreeBranch | undefined>;
}

interface ConnectedDispatch {

}

interface OwnState {

}

export class FooterComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {
    public render() {
        const home = this.props.navItems.find((b) => b !== undefined && !b.parentIds.length);
        if (!home)
            return null;

        let children = this.props.navItems.filter((b) => {
            return b !== undefined && b.onNav && home.childIds.indexOf(b.id) > -1;
        }).toList();

        children = children.push(home)
            .sortBy((b) => b !== undefined && b.sort)
            .toList();

        const navItems = children.map((item, i) => {
            if (!item || !item.onNav)
                return null;

            return (
                <li key={i}>
                    <NavLink exact to={item.url}>
                        {item.title}
                    </NavLink>
                </li>
            );
        });

        return (<div id="footer">
            <div id="footer-nav-primary">
                <ul>{navItems}</ul>
            </div>

            <div id="footer-nav-secondary">
                <ul>
                    <li><a href={Settings.AsrsLegacyUrl + "/about/contact-us"}>Contact Us</a></li>
                    <li><a href={Settings.AsrsLegacyUrl + "/join-asrs"}>Join the ASRS</a></li>
                    <li><Link to={Paths.Account.Login}>Sign in</Link></li>
                </ul>
            </div>

            <address className="vcard">
                <span className="org">American Society of <strong>Retina Specialists</strong></span>
                <span className="adr">
                <span className="street-address">5315 North Clark Street, Suite 311, </span>
                <span className="locality">Chicago, Illinois 60640</span>
                </span>
                <span className="tel">(312) 578-8760 phone</span>
                <span className="contact"><a href="mailto:info@asrs.org">info@asrs.org</a></span>
            </address>

            <ul id="footer-social">
                <li><a href="https://twitter.com/asrsdocs" title="ASRS on Twitter"><Icon icon="twitter" /></a></li>
                <li><a href="https://www.instagram.com/asrs.retinaspecialists" title="ASRS on Instagram"><Icon icon="instagram" /></a></li>
            </ul>

            <div id="copyright">
                &copy; {new Date().getFullYear()} {Settings.ClientName}. All rights reserved.{" "}
                <a href={Settings.AsrsLegacyUrl + "/privacy-statement"}>Privacy statement</a>.{" "}
                <a href={Settings.AsrsLegacyUrl + "/terms-of-use"}>Terms of use</a>.
            </div>
        </div>
        );
    }
}

export const Footer: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(FooterComponent);



// WEBPACK FOOTER //
// ./src/components/layout/Footer.tsx